import { Autocomplete, Box, Grid, TextField } from "@mui/material";
import useGlobal from "./Global";
import { useEffect, useState } from "react";
import CustButton from "../ui/CustButton";
import { Clear, FilterAlt } from "@mui/icons-material";


const DynamicFilter = ({ filterList, onFilter, loading }) => {

    const [filters, setFilters] = useState({});

    const [filteredOptions, setFilteredOptions] = useState({});

    const { t } = useGlobal();

    const parentFilters = filterList
        .filter(filter => filter.parent) // Get filters that have a parent
        .map(filter => filter.parent);


    useEffect(() => {

        // When a parent filter changes, reset dependent filters
        filterList.forEach(filter => {

            if (filter.parent && filters[filter.parent]) {

                // Filter options based on the selected parent value
                const parentValue = filters[filter.parent];
                const newOptions = filter.options.filter(opt => opt.filterKey === parentValue);

                setFilteredOptions(prev => ({
                    ...prev,
                    [filter.key]: newOptions,
                }));
            } else if (filter.parent) {
                // Reset if parent is not selected
                setFilters(prev => ({ ...prev, [filter.key]: "" }));
                setFilteredOptions(prev => ({ ...prev, [filter.key]: [] }));
            }
        });
    }, parentFilters.map(parent => filters[parent]));  // Only run when `sehirKodu` changes


    const renderFilterComponent = (filter) => {
        switch (filter.tipi) {
            case "text":
                return (
                    <TextField
                        key={filter.key}
                        label={filter.label}
                        variant='outlined'
                        margin='dense'
                        InputLabelProps={{ shrink: true }}
                        value={filters[filter.key] || ""}
                        fullWidth
                        onChange={(e) => setFilters(prev => ({ ...prev, [filter.key]: e.target.value }))}
                    />
                );
            case "auto":
                return (
                    <Autocomplete
                        key={filter.key}
                        options={filter.parent ? filteredOptions[filter.key] || [] : filter.options} // Use filtered options if it has a parent
                        getOptionLabel={(option) => option.text}
                        isOptionEqualToValue={(option, value) => option.value === value?.value}
                        renderInput={(params) => (
                            <TextField {...params} label={filter.label} variant="outlined" margin="dense" />
                        )}
                        renderOption={(props, option) => (
                            <li {...props} key={option.value}>
                                {option.text}
                            </li>
                        )}
                        value={filter.options.find(opt => opt.value === filters[filter.key]) || null}
                        onChange={(_, value) => {
                            setFilters(prev => ({
                                ...prev,
                                [filter.key]: value?.value || "",
                            }));
                        }}
                        fullWidth
                    />
                );
            case "enum":
                return (
                    <></>
                );
            default:
                return null;
        }
    };

    return (
        <Box className="box">
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    {filterList?.map(filter => renderFilterComponent(filter))}

                </Grid>
                <Grid item xs={12}>
                    <CustButton
                        icon={FilterAlt}
                        onClick={() => onFilter(filters)}
                        style={{ ml: 10, mr: 10 }}
                        fullWidth
                        disabled={loading}
                    >
                        {t("action.filter")}
                    </CustButton>
                </Grid>
                <Grid item xs={12}>
                    <CustButton
                        icon={Clear}
                        onClick={() => {
                            setFilters([]);
                            onFilter([]);
                        }}
                        style={{ ml: 10, mr: 10 }}
                        fullWidth
                        disabled={loading}
                    >
                        {t("action.ClearFilter")}
                    </CustButton>
                </Grid>

            </Grid>
        </Box>
    );

}

export default DynamicFilter;